const PresentationChart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 12V15.75M13.5 15.75L10.5364 13.2804C9.98986 12.8249 9.71657 12.5971 9.4115 12.5101C9.14253 12.4334 8.85747 12.4334 8.5885 12.5101C8.28343 12.5971 8.01014 12.8249 7.46356 13.2804L4.5 15.75M6 8.25V9M9 6.75V9M12 5.25V9M16.5 2.25H1.5M2.25 2.25H15.75V8.4C15.75 9.66012 15.75 10.2902 15.5048 10.7715C15.289 11.1948 14.9448 11.539 14.5215 11.7548C14.0402 12 13.4101 12 12.15 12H5.85C4.58988 12 3.95982 12 3.47852 11.7548C3.05516 11.539 2.71095 11.1948 2.49524 10.7715C2.25 10.2902 2.25 9.66012 2.25 8.4V2.25Z"
      stroke="#6D28D9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PresentationChart;
